import {
  SourceEntityMigrationType,
  type ISourceEntity,
  ISourceEntityTypes,
} from '@principle-theorem/practice-migrations/interfaces';
import { TypeGuard, type Timezone } from '@principle-theorem/shared';
import { isString } from 'lodash';
import { BaseSourceEntity } from '../../../source/base-source-entity';
import { SourceEntity } from '../../../source/source-entity';

export const PATIENT_ALLERGY_OPTIONS_RESOURCE_TYPE = 'patientAllergyOptions';

export const PATIENT_ALLERGY_OPTIONS_SOURCE_ENTITY: ISourceEntity =
  SourceEntity.init({
    metadata: {
      label: 'Patient Allergy Options',
      description: '',
      idPrefix: PATIENT_ALLERGY_OPTIONS_RESOURCE_TYPE,
      migrationType: SourceEntityMigrationType.Automatic,
    },
  });

export interface ICorePracticePatientAllergyOptions {
  description: string; // "Codeine"
}

export function isCorePracticePatientAllergyOption(
  item: unknown,
  logError: boolean
): item is ICorePracticePatientAllergyOptions {
  return TypeGuard.interface<ICorePracticePatientAllergyOptions>(
    {
      description: isString,
    },
    logError
  )(item);
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ICorePracticePatientAllergyOptionsTranslations {}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ICorePracticePatientAllergyOptionsFilters {}

const PATIENT_ALLERGY_OPTIONS_SOURCE_QUERY = `
SELECT
  Description AS description
FROM tblPatientAllergy
WHERE description IS NOT NULL
GROUP BY Description
`;

export type CorePracticePatientAllergyOptions = ISourceEntityTypes<
  ICorePracticePatientAllergyOptions,
  ICorePracticePatientAllergyOptionsTranslations,
  ICorePracticePatientAllergyOptionsFilters
>;

export class PatientAllergyOptionsSourceEntity extends BaseSourceEntity<CorePracticePatientAllergyOptions> {
  sourceEntity = PATIENT_ALLERGY_OPTIONS_SOURCE_ENTITY;
  entityResourceType = PATIENT_ALLERGY_OPTIONS_RESOURCE_TYPE;
  sourceQuery = PATIENT_ALLERGY_OPTIONS_SOURCE_QUERY;
  verifySourceFn = isCorePracticePatientAllergyOption;

  translate(
    _data: ICorePracticePatientAllergyOptions,
    _timezone: Timezone
  ): ICorePracticePatientAllergyOptionsTranslations {
    return {};
  }

  getSourceRecordId(data: ICorePracticePatientAllergyOptions): string {
    return data.description;
  }

  getSourceLabel(data: ICorePracticePatientAllergyOptions): string {
    return data.description;
  }

  getFilterData(
    _data: ICorePracticePatientAllergyOptions,
    _timezone: Timezone
  ): ICorePracticePatientAllergyOptionsFilters {
    return {};
  }
}
